import React from 'react';

export default props => {
  return (
    <div
      className="section row"
      style={{ padding: '25px', border: '2px solid red' }}
    >
      <p className="fill" style={{ textAlign: 'center' }}>
        This practice is not verified. If you are the administrator of this
        practice, log in to{' '}
        <a href="https://dashboard.dpcfrontier.com">
          the DPC Frontier dashboard
        </a>{' '}
        and press "Submit for verification".
      </p>
    </div>
  );
};
